import type {
  PortalRedirectRequest,
  PortalRedirectResponse,
} from '../../types/portal/portalEstipulanteType';
import { PORTAL_ESTIPULANTE_ROUTES } from '../requestsService';

export class PortalEstipulanteService {
  private fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>;

  constructor(fetch: <T>(endpoint: string, options?: RequestInit) => Promise<T>) {
    this.fetch = fetch;
  }

  /**
   * Prepares Web Vida / Portal do Estipulante auto-login.
    * Returns the complete SSO2 URL to open in a new tab.
   * POST /v1/bff/portal-estipulante/redirect
   */
  async createRedirect(request: PortalRedirectRequest): Promise<PortalRedirectResponse> {
    return this.fetch<PortalRedirectResponse>(
      PORTAL_ESTIPULANTE_ROUTES.POST_REDIRECT,
      {
        method: 'POST',
        body: JSON.stringify(request),
      },
    );
  }
}
